export * from './background-image.component';
